import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ViewCohort from './viewCohort/ViewCohort'
import CreateCohort from './createCohort/CreateCohort'
import EditCohort from './editCohort/EditCohort'
import ViewLearners from './viewCohort/ViewLearners'
import LearnerProfile from './viewCohort/LearnerProfile'
import ActionPlan from './actionPlan/ActionPlan'
import ActionPlanLearners from './actionPlan/ActionPlanLearners'
import SurveyResponse from './actionPlan/SurveyResponse'


const Cohorts: React.FC = () : React.ReactElement => {
  return (
    <div>
        <Routes>
            <Route path="/" element={<ViewCohort />} />
            <Route path="/create" element={<CreateCohort />} />
            <Route path="/edit/:id" element={<EditCohort />} />
            <Route path="/view/:id" element={<ViewLearners />} />
            <Route path="/action-plan/:id" element={<ActionPlan />} />
            <Route path="/action-plan-learners/:id/:activeCohortId" element={<ActionPlanLearners />} />
            <Route path="/survey-response/:cohortId/:actionPlanId/:surveyId/:responseId" element={<SurveyResponse />} />
            <Route path="/learner/:id" element={<LearnerProfile />} />
        </Routes>
    </div>
  )
}

export default Cohorts